<template>
  <div v-loading="loading" style="height: 350px;width: 100%;" />
</template>

<script>
import { totalDevCurveApi } from '@/api/common/reportApi'
import { debounce } from '@/utils/common'

export default {
  name: 'ReportBar',

  props: {
    type: {
      type: String,
      default: 'day'
    }
  },

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
        },
        legend: {
          show: false,
          bottom: 0
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 50,
          top: 50,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: [],
          boundaryGap: true
        },
        yAxis: [{
          type: 'value'
        }],
        series: [
          {
            name: '设备数量',
            type: 'bar',
            barMaxWidth: '50',
            data: []
          },
        ]
      }
    }
  },

  watch: {
    type: function(newVal,oval) {
      this.fetchData()
    }
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  created: function() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      totalDevCurveApi({ type: this.type }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.xAxis.data = this.stats.x_data
      this.chartOption.series[0].data = this.stats.y_data
      this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
